import React, { useState, useEffect } from 'react';

import { useHttpStatus, useComparable } from '../hooks';
import ListTable from './ListTable.jsx';
import ListPagination from './ListPagination.jsx';
import AnimPending from './AnimPending.jsx';
import FormHttpAlert from './FormHttpAlert.jsx';

const ListHttpTable = ({
  api,
  cols,
  skip = 0,
  limit = 20,
  sort,
  filter = {},
  onSelect,
  onRowClick,
  className,
  refresh,
  setRefresh,
  children,
}) => {
  const [selected, setSelected] = useState([]);
  const [query, setQuery] = useState({
    skip,
    limit,
    sort,
  });
  const [
    res,
    req,
    fetched = { rows: [], total: 0 },
  ] = useHttpStatus({
    onSuccess() {
      // clear select
      if (onSelect) {
        setSelected([]);
        onSelect([]);
      }
    },
  });

  const fetch = (q) => {
    const nq = { ...query, ...q };

    setQuery(nq);
    req({
      ...api,
      params: {
        ...nq,
        filter,
      },
    });
  };

  useEffect(() => {
    fetch({ skip: 0 });
  }, [
    refresh,
    useComparable({ filter, api }),
  ]);

  return (
    <div>
      <FormHttpAlert res={res} />
      <div className="form-row mb-3">
        <div className="col">{children}</div>
        <ListPagination
          {...{
            className: 'col-auto',
            ...query,
            total: fetched.total,
            onChange: fetch,
          }}
        />
      </div>
      <div className="position-relative">
        {res.status === 'pending' && (
          <div className="position-absolute fill">
            <div className="position-absolute fill bg-white opacity-5" />
            <AnimPending />
          </div>
        )}
        <ListTable
          {...{
            className,
            cols,
            rows: fetched.rows,
            onRowClick,
            selected: onSelect ? selected : null,
            onSelect: onSelect ? (s) => {
              setSelected(s);
              onSelect(s.map((i) => (
                fetched.rows[i]
              )));
            } : undefined,
            sort: query.sort,
            // when user changes sorting, reset to the first page (skip: 0)
            // so the returned ranks and rows reflect the top of the newly
            // sorted result instead of remaining on a later page.
            onSort: (s) => fetch({ sort: s, skip: 0 }),
            refresh,
            setRefresh,
          }}
        />
      </div>
    </div>
  );
};

export default ListHttpTable;
